import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Controller } from "react-hook-form";
import {IDaSelectFieldProps} from "./types";

export const DaSelectField: React.FC<IDaSelectFieldProps<any>> = (
    {
        control,
        name,
        label,
        selectListItems = [],
        defaultValue = "",
        required = false,
        size = "medium",
        variant = "standard",
        errors,
        showNone = true
    } : IDaSelectFieldProps<any>

) => {
    const labelId = `${name}-label`;
    return (
        <FormControl variant={variant} size={size} error={!!errors[name]} fullWidth>
            <InputLabel id={labelId}>{required ? `${label} *` : label}</InputLabel>
                <Controller
                    name={name}
                    control={control}
                    render={({ field }) =>
                    <Select
                        {...field}
                        labelId={labelId}
                        label={required ? `${label} *` : label}
                    >
                        {showNone && <MenuItem value="">None</MenuItem>}
                        {selectListItems.map((item) => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.label ? item.label : item.value}
                            </MenuItem>
                        ))}
                    </Select>
                    }
                />
            <FormHelperText>{errors[name]?.message ?? ''}</FormHelperText>
        </FormControl>
    );
};